/**
 * Display a custom message once your service worker finds an update
 * The following code will display a confirm prompt asking the user whether they
 * would like to refresh the page when an update is found.
 */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './src/i18n/i18n';
import { initAmplitude } from './src/services/amplitude';
import { SentryService } from './src/services/sentry';

export { wrapPageElement } from './wrap-page-element';

export const onServiceWorkerUpdateReady = () => {
  if (process.env.GATSBY_ENV !== 'dev') return;
  const answer = window.confirm('This application has been updated. Reload to display the latest version?');
  if (answer === true) {
    window.location.reload();
  }
};

const safeDecode = (value) => {
  try {
    return decodeURIComponent(value);
  } catch {
    // malformed escape sequence, use the value as is
    return value;
  }
};

const skipDefaultScroll = (location, prevLocation) =>
  Boolean(location.hash) && location.pathname === prevLocation?.pathname;

export const shouldUpdateScroll = ({ routerProps: { location }, prevRouterProps }) =>
  !skipDefaultScroll(location, prevRouterProps?.location);

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!skipDefaultScroll(location, prevLocation)) return;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const id = safeDecode(location.hash.slice(1));
  document.getElementById(id)?.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth' });
};

export const onClientEntry = () => {
  SentryService.init();

  const amplitudeApiKey = process.env.AMPLITUDE_API_KEY;
  if (amplitudeApiKey) {
    initAmplitude(amplitudeApiKey);
  }
};
